/* DCL homepage: line indicators above sideways rows, phone and small tablet only (CSS hides them above 900px).
   Same look as the brands section dots. One line per screen of cards; the red line follows the scroll. */
(function(){
  if (window.__dclRailDots) return; window.__dclRailDots = true;
  var SEL = '.dclh-rides__grid,.dclh-np__rail,.dclh-po__rail';
  function init(){
    document.querySelectorAll(SEL).forEach(function(r){
      if (r.previousElementSibling && r.previousElementSibling.classList.contains('dclh-raildots')) return;
      var bar = document.createElement('div');
      bar.className = 'dclh-dots dclh-raildots'; bar.setAttribute('role', 'group'); bar.setAttribute('aria-label', 'Scroll position');
      r.parentNode.insertBefore(bar, r);
      var n = 0, dots = [];
      function max(){ return Math.max(0, r.scrollWidth - r.clientWidth); }
      function build(){
        var k = r.clientWidth ? Math.ceil(r.scrollWidth / r.clientWidth - 0.05) : 0;
        if (k === n) return; n = k; bar.innerHTML = ''; dots = [];
        bar.hidden = n < 2;
        for (var j = 0; j < n; j++) {
          var d = document.createElement('button'); d.type = 'button'; d.className = 'dclh-dot';
          d.setAttribute('aria-label', 'Show set ' + (j + 1) + ' of ' + n);
          (function(j){ d.addEventListener('click', function(){ r.scrollTo({ left: n > 1 ? max() * j / (n - 1) : 0, behavior: 'smooth' }); }); })(j);
          bar.appendChild(d); dots.push(d);
        }
        update();
      }
      function update(){
        if (n < 2) return;
        var m = max(), a = m ? Math.round(r.scrollLeft / m * (n - 1)) : 0;
        dots.forEach(function(d, j){ d.setAttribute('aria-current', j === a ? 'true' : 'false'); });
      }
      r.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', build);
      build();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
